import { prsDrsCostApprovalActions } from './prsDrsCostApprovalActionCreator';

const initialState = {
  loading: false,
  loadingSubRow: false,
  prsDrsData: [],
  prsOrDrsConsginmmentData: [],
  handlingCostComponents: [],
  rejectionsReasons: null,
  loaderModal: false
};

const prsDrsCostApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case prsDrsCostApprovalActions.SET_LOADER_MODAL:
      return { ...state, loaderModal: action.payload };
    case prsDrsCostApprovalActions.SET_IS_LOADING:
      return { ...state, loading: action.payload };
    case prsDrsCostApprovalActions.SET_PRS_DRS_DATA:
      return { ...state, prsDrsData: action.payload };
    case prsDrsCostApprovalActions.SET_PRS_OR_DRS_CONSIGNMENT_DATA:
      return { ...state, prsOrDrsConsginmmentData: action.payload };
    case prsDrsCostApprovalActions.SET_LOADING_SUB_ROW:
      return { ...state, loadingSubRow: action.payload };
    case prsDrsCostApprovalActions.SET_CONSIGNMENTS_FOR_PRS_DRS:
      const newPrsDrsData = [...state.prsDrsData];
      newPrsDrsData[action.payload.rowIndex].subRows = action.payload.subRows;
      return { ...state, prsDrsData: newPrsDrsData };
    case prsDrsCostApprovalActions.SET_HANDLING_COST_COMPONENTS:
      return { ...state, handlingCostComponents: action.payload };
    case prsDrsCostApprovalActions.SET_REJECTION_REASONS:
      return { ...state, rejectionsReasons: action.payload };
    default:
      return { ...state };
  }
};

export default prsDrsCostApprovalReducer;
